var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBusinnesEcoLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 38,
    viewBox: "0 0 34 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6074 37.5109C23.19 37.5109 30.9552 29.7432 30.9552 20.1631H13.6074V37.5109Z",
    fill: "url(#paint0_linear_5169_30569)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4689 20.1603C33.4689 9.18975 24.5756 0.298828 13.6074 0.298828V20.1603H33.4689Z",
    fill: "url(#paint1_linear_5169_30569)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5738 7.05566C6.33562 7.05566 0.46875 12.9225 0.46875 20.1607H13.5738V7.05566Z",
    fill: "#6DC9F0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5169_30569",
    x1: 27.6,
    y1: 11.3536,
    x2: 12.6604,
    y2: 41.7665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1994,
    stopColor: "#58C1EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#195BA7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5169_30569",
    x1: 3.34382,
    y1: -1.39422,
    x2: 33.7984,
    y2: 24.1218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2007,
    stopColor: "#52C3F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1774BB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinnesEcoLogo);
export default __webpack_public_path__ + "static/media/businnes-eco-logo.bd41394f640891bae9875e9870f82c36.svg";
export { ForwardRef as ReactComponent };